<template>
  <v-menu v-model="menu" location="bottom end" :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <AppkitIcon
        class="menu-container"
        v-bind="props"
        :icon="menuIcon"
        :size="'small'"
      ></AppkitIcon>
    </template>
    <v-card class="pa-2 d-flex flex-column align-start">
      <div v-for="menuItem in menuItems">
        <div
          v-if="menuItem.visible"
          class="menu-container__item d-flex"
          @click="emit('menuItemClicked', menuItem)"
        >
          <AppkitIcon v-if="menuItem.icon" class="mr-3" :icon="menuItem.icon" />
          {{ menuItem.title }}
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import type { SideMenuItem } from "@/models/sideMenuItem";
import AppkitIcon from "./AppkitIcon.vue";
import { ref } from "vue";

defineProps<{
  menuItems: SideMenuItem[];
  menuIcon: string;
}>();

const emit = defineEmits<{
  (e: "menuItemClicked", item: SideMenuItem): void;
}>();

const menu = ref(false);
</script>

<style scoped lang="scss">
.menu-container {
  &:hover {
    cursor: pointer;
  }
}

.menu-container__item {
  padding: 8px;
  &:hover {
    cursor: pointer;
    background-color: var(--lighter-grey);
    border-radius: 6px;
  }
}
</style>
